// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getInvoiceByKey } from '@/billing/api/get-invoice';
import { useQuery } from '@tanstack/react-query';

export function useInvoice(invoiceKey: string) {
  const { data, isLoading, isFetching, error } = useQuery({
    queryKey: ['invoices', 'detail', invoiceKey],
    queryFn: () => getInvoiceByKey(invoiceKey),
    enabled: invoiceKey.length > 0,
  });

  return {
    invoice: data ?? null,
    isLoading,
    isFetching,
    error,
  };
}
